import styled from 'styled-components/macro';
import { colorAccentLinkLight, colorCoreGray200, colorCoreWhite1000, hexColorBlackTransparent50, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { ADAPTIVE } from '@yme/tokens/screen';
import { getTextStyles } from '@yme/utils/styles';
export const CookieListStyled = styled.div `
  padding: 24px 16px;
  background-color: ${colorCoreWhite1000};

  ${({ isShowSkeleton }) => isShowSkeleton && 'display: none;'}

  #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy {
    width: 100%;
  }

  #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy .ot-sdk-cookie-policy-title {
    margin-bottom: 16px;

    ${getTextStyles('Play', 700, 18, 24)}
  }

  #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy #cookie-policy-description {
    margin-bottom: 32px;

    ${getTextStyles('Ubuntu', 400, 16, 24)}
  }

  #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy .ot-sdk-cookie-policy-group {
    margin-bottom: 8px;

    ${getTextStyles('Play', 700, 16, 24)}
  }

  #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy .ot-sdk-cookie-policy-group-desc {
    margin-bottom: 24px;

    ${getTextStyles('Ubuntu', 400, 16, 24)}
  }

  #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy table {
    border-color: ${hexColorBlackTransparent50};
    border-radius: ${CORNER_RADIUS.xs};
  }

  #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy .ot-table-header {
    ${getTextStyles('Ubuntu', 500, 16, 24)}
  }

  #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy td {
    ${getTextStyles('Ubuntu', 400, 14, 20)}
  }

  #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy table th {
    border-bottom: 1px solid ${hexColorBlackTransparent50};
    border-right: none;
  }

  #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy table td {
    border-bottom: none;
    border-right: none;
  }

  #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy tr:nth-child(2n) td {
    background-color: ${colorCoreGray200};
  }

  #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy a {
    color: ${colorAccentLinkLight};
  }

  #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy .ot-sdk-subgroup {
    margin-left: 0;
  }

  #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy section:last-child {
    margin-bottom: 0;

    p:last-child {
      margin-bottom: 0;
    }
  }

  #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy p {
    line-height: inherit;
  }

  #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy thead tr {
    position: initial;
  }

  #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy table {
    display: table;
  }

  #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy tr {
    display: table-row;
  }

  #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy th,
  #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy td {
    display: table-cell;
    box-sizing: border-box;
    max-width: 200px;
    min-width: 200px;
    vertical-align: top;
    word-break: break-word;
  }

  #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy td:before {
    display: none;
  }

  #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy table .ot-host,
  #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy table .ot-cookies-type {
    width: initial;
  }

  #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy .table-wrapper {
    overflow-x: auto;
    user-select: none;
    scrollbar-width: none;
  }

  ${ADAPTIVE.minWidth.tablet} {
    padding: 24px;

    #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy .ot-sdk-cookie-policy-title {
      ${getTextStyles(null, null, 24, 28)}
    }

    #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy .ot-sdk-cookie-policy-group {
      ${getTextStyles(null, null, 18, 24)}
    }
  }

  ${ADAPTIVE.minWidth.desktop} {
    padding: 48px;

    #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy th,
    #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy td {
      min-width: initial;
      max-width: initial;
    }

    #ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy table {
      table-layout: fixed;
    }
  }
`;
